module.exports = __webpack_public_path__ + "static/media/automatic_box.cd249089.svg";